module.exports = __webpack_public_path__ + "img/logo.6eb59fbf.png";